import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import AddRule from "../AddRule/AddRule";

export default function TopCard({ reload, userType }) {
  const [isDialogVisible, setDialogVisible] = useState(false);

  const handleAddRule = () => setDialogVisible(true);
  const handleClose = () => setDialogVisible(false);

  return (
    <div
      style={{
        height: 45,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      {userType === 1 && (
        <button
          onClick={handleAddRule}
          className="NavLinkBtn large unselectlink marginright"
          aria-label="Add new trading rule"
        >
          ADD RULES
        </button>
      )}

      <Dialog
        visible={isDialogVisible}
        onHide={handleClose}
        position="center"
        closeOnEscape
        closeIcon
        transitionOptions={false}
        focusOnShow={false}
        draggable={false}
        resizable={false}
        header="Add New Rule"
      >
        <AddRule close={handleClose} reload={reload} />
      </Dialog>
    </div>
  );
}
